/* eslint-disable import/no-cycle */
import { call, put, takeEvery } from 'redux-saga/effects';
import { signup, phone } from '../../api/api';
import history from '../../router/history';

import {
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILURE,
  CREATE_PHONE_CODE_SIGNUP,
  CREATE_PHONE_CODE_SIGNUP_SUCCESS,
  CREATE_PHONE_CODE_SIGNUP_FAILURE,
  ACCEPT_COWORKER_INVITATION,
  ACCEPT_COWORKER_INVITATION_SUCCESS,
  ACCEPT_COWORKER_INVITATION_FAILURE
} from './signupActions';

import logger from '../../utils/logger';

export function* createPhoneCode(action) {
  try {
    const response = yield call(phone.createPhoneCode, action.payload);
    if (response.data.success === true) {
      yield put({ type: CREATE_PHONE_CODE_SIGNUP_SUCCESS });
    }
  } catch (error) {
    logger(error);
    yield put({ type: CREATE_PHONE_CODE_SIGNUP_FAILURE });
  }
}

export function* createCustomer(action) {
  try {
    const response = yield call(signup.createCustomer, action.payload);
    if (response.data.success === true) {
      yield put({ type: CREATE_CUSTOMER_SUCCESS });
      localStorage.setItem('token', response.data.token);
      yield call(history.push, '/not-sent');
    }
  } catch (error) {
    logger(error);
    yield put({ type: CREATE_CUSTOMER_FAILURE });
  }
}

export function* acceptCoworkerInvitation(action) {
  try {
    const response = yield call(
      signup.acceptCoworkerInvitation,
      action.payload
    );
    if (response.data.success === true) {
      yield put({ type: ACCEPT_COWORKER_INVITATION_SUCCESS });
      localStorage.setItem('token', response.data.token);
      yield call(history.push, '/not-sent');
    }
  } catch (error) {
    logger(error);
    yield put({ type: ACCEPT_COWORKER_INVITATION_FAILURE });
  }
}

const signinSaga = [
  takeEvery(CREATE_PHONE_CODE_SIGNUP, createPhoneCode),
  takeEvery(CREATE_CUSTOMER, createCustomer),
  takeEvery(ACCEPT_COWORKER_INVITATION, acceptCoworkerInvitation)
];

export default signinSaga;
